import { render, staticRenderFns } from "./adms-visitors-chart.vue?vue&type=template&id=4486c87d&scoped=true&lang=pug&"
import script from "./adms-visitors-chart.vue?vue&type=script&lang=ts&"
export * from "./adms-visitors-chart.vue?vue&type=script&lang=ts&"
import style0 from "./adms-visitors-chart.vue?vue&type=style&index=0&id=4486c87d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4486c87d",
  null
  
)

export default component.exports